import { UseInfiniteQueryOptions } from '@tanstack/react-query';
import { ListUserAPIOutput } from 'lib/api/firebase/apis/apis';

export const infiniteQueryOptions = <FnQueryData, ErrorType>(
  args: Omit<UseInfiniteQueryOptions<FnQueryData, ErrorType>, 'queryKey'>
) => args;
type ApiOutput = {
  data: ListUserAPIOutput<any>;
};
/**
 * TODO: Wrap this method in `infiniteQueryOptions`.
 * There were issues with the typing of the queryKey
 *
 * @param clinicId
 * @returns
 */
export const baseInfiniteQueryOptions = (clinicId: string) => ({
  retry: false,
  getNextPageParam: (lastPage: ApiOutput) =>
    lastPage.data.cursor === null ? undefined : lastPage.data.cursor,
  enabled: !!clinicId
});
